import { render, staticRenderFns } from "./ShippingV2.vue?vue&type=template&id=4d35d060"
import script from "./ShippingV2.vue?vue&type=script&lang=js"
export * from "./ShippingV2.vue?vue&type=script&lang=js"
import style0 from "./ShippingV2.vue?vue&type=style&index=0&id=4d35d060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports